import { createSlice } from "@reduxjs/toolkit";
import { fetchFeatureInfoThunk } from "./gisThunk";

const initialState: any = {
    coordinates: [0, 0],
    selectedLayers: ['India Boundary'],
    removedLayers: [],
    chainageType: '',
    selectedBaseMap: 'osm',
    lane: '',
    searchCoordinates: {
        latitude: 0,
        longitude: 0,
    },
    selectedStretch: [],
    featureInfo: null,
    featureInfoLoading: false,
    featureInfoError: null,
}

const GISDataSlice = createSlice({
    name: "GISDataSlice",
    initialState,
    reducers: {
        setSearchCoordinates(state, action) {
            state.searchCoordinates = action.payload;
        },
        setCoordinates(state, action) {
            state.coordinates = action.payload;
        },
        setSelectedLayers(state, action) {
            state.selectedLayers = action.payload;
        },
        setRemovedLayer(state, action) {
            state.removedLayers = action.payload;
        },
        resetRemovedLayer(state) {
            state.removedLayers = [];
        },
        setSelectedUCC(state, action) {
            state.selectedUCC = action.payload;
        },
        setSelectedBaseMap(state, action) {
            state.selectedBaseMap = action.payload;
        },
        setLanes(state, action) {
            state.lane = action.payload;
        },
        setSelectedStretch(state, action) {
            state.selectedStretch = action.payload;
        },
        resetLanes(state) {
            state.lane = initialState.lane;
        },
        resetFeatureInfo(state) {
            state.featureInfo = null;
            state.featureInfoError = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchFeatureInfoThunk.pending, (state) => {
                state.featureInfoLoading = true;
                state.featureInfoError = null;
            })
            .addCase(fetchFeatureInfoThunk.fulfilled, (state, action) => {
                state.featureInfoLoading = false;
                state.featureInfo = action.payload;
            })
            .addCase(fetchFeatureInfoThunk.rejected, (state, action) => {
                state.featureInfoLoading = false;
                state.featureInfoError = action.payload as string;
            });
    },
});

export const { 
    setSelectedStretch, 
    setSearchCoordinates, 
    setLanes, 
    resetLanes, 
    setCoordinates, 
    setSelectedLayers, 
    setSelectedUCC, 
    setRemovedLayer, 
    resetRemovedLayer, 
    setSelectedBaseMap,
    resetFeatureInfo
} = GISDataSlice.actions;
export default GISDataSlice.reducer;